module.exports = __webpack_public_path__ + "img/tajikistan.79303a1c.svg";